<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>车辆过出列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card" >
      <!-- 搜索  新增-->
      <el-form
          :inline="false"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="车牌号|所属人" size="small" label-width="120px">
              <el-input v-model="searchForm.queryParams" placeholder="请输入车牌号" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="开始时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间" style="width: 80%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间" size="small" label-width="70px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择结束时间" style="width: 80%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        stripe
        border
        height="450" :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
      >
        <el-table-column
            label="ID"
            min-width="5%"
            prop="id"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
          label="档案编号"
          min-width="8%"
          prop="file_no"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="发证单位"
          min-width="10%"
          prop="unit"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="车牌"
          prop="plate_number"
          min-width="10%"
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          label="所属人"
          min-width="10%"
          prop="allPerson"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="是否是主车"
          min-width="10%"
          prop="main"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <!--
        <el-table-column
          label="是否是挂车"
          min-width="10%"
          prop="trailer"
          :show-overflow-tooltip='true'>
        </el-table-column>-->
        <el-table-column
          label="经办人名称"
          min-width="10%"
          prop="op_name"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="收费金额"
          min-width="10%"
          prop="收费金额"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="成本价格"
          min-width="10%"
          prop="chengben"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="押金金额"
          min-width="10%"
          prop="yajin"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="备注"
          min-width="10%"
          prop="composition"
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          label="操作"

          min-width="10%"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="small" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="档案编号"  size="small">
              <el-input v-model="form.file_no" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="挂靠单位"  size="small">
              <el-input v-model="form.unit" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <!--车辆-->
           <carListTemp ref="carListTemp" @changeData="setcarInfo"></carListTemp>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属人" prop="allPerson" size="small">
              <el-input v-model="form.allPerson" autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="是否是主车" prop="" size="small">
              <el-input v-model="form.main" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否是挂车" prop="" size="small">
              <el-input v-model="form.trailer" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="收费金额" prop="fee" size="small">
              <el-input v-model="form.fee" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成本金额" prop="" size="small">
              <el-input v-model="form.chengben" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="押金金额" prop="" size="small">
              <el-input v-model="form.yajin" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="" size="small">
              <el-input v-model="form.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <!--
          <el-col :span="12">
            <shopCompanyTemp ref="shopCompanyTemp"></shopCompanyTemp>
          </el-col>-->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import eTable from "../common/eTable.vue";
  import moment from 'moment';     //日期时间转换
  import shopCompanyTemp from "../common/shopCompanyTemp.vue";
  import carListTemp from "../common/carlistTemp.vue";
  export default {
    name: "leaveList",
    components: {
      eTable,
      shopCompanyTemp,
      carListTemp
    },
    props: {},
    data() {
      return {
        // 搜索
        searchForm: {
          queryParams:'',
          start_time:'',
          end_time:''
        },
        searchRules: {
        },
        // 数据
        tableLoadData: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        rules: {
          allPerson:[{ required: true, message: "请输入所属人", trigger: "blur" }],
          fee:[{required: true, message: '请输入费用', trigger: 'blur' },
            {pattern:'([1-9]\\d*(\\.\\d*[1-9])?)|(0\\.\\d*[1-9])',message: '费用必须大于0',trigger: 'blur'}
          ],
        },
        dialogFormVisible: false,
        title: '',
        form: {
          file_no:'',//档案编号
          unit:'',//挂靠单位
          car_id:'', // 车辆id
          shop_id:'', //运输公司id
          //old_allPerson:'',
          allPerson:'', //所属人
          main:'', //是否是主车
          fee:'', //收费金额
          chengben:'', //成本金额
          yajin:'', //押金金额
          remark:'', //备注
        },
        uploadImg: '',
        uploadDialog: false
      };
    },
    created() {
      this.DataList()
    },
    mounted() {},
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },

    },
    methods: {
      setcarInfo(value){
        this.$set(this.form,'allPerson' , value.allPerson) //不用set 的形式，页面数据不更新
        //this.form.vin = value.vin
        //this.form.model = value.model
        // this.form.issue_date = value.issue_date
        // this.form.register_date = value.register_date
      },
      getTime (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return y + '-' + m + '-' + d
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
          pageSize:this.limit
        }
        if(this.searchForm.queryParams) param.queryParams = this.searchForm.queryParams
        if(this.searchForm.start_time) param.start_time =  this.getTime(this.searchForm.start_time)
        if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)

        this.$axios.getOverstep(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      // 新增
      addData() {
        this.title = '新增'
        this.form = {
          // role_name: '',
        }
        this.dialogFormVisible = true
      },
      handelEdit(index,row) {
        this.id = index.id

        this.title = '编辑'
        this.form = {
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              car_id: this.$refs.carListTemp.form.car_id,//this.form.car_id,
              //shop_id: this.$refs.shopCompanyTemp.form.shop_id,//this.form.shop_id,
              allPerson: this.form.allPerson,
              fee:this.form.fee,
              chengben:this.form.chengben,
              yajin:this.form.yajin,
              remark: this.form.remark,
              main:this.form.main,
              file_no:this.form.file_no,
              unit:this.form.unit,
              operator_id: sessionStorage.getItem('user_id'),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token')
            }
            this.$axios.saveOverstep(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.dialogFormVisible = false
              }else{
                this.$message.error(res.msg);
              }
            })
            if(this.id) param.id = this.id
          }
        })
      },
      searchSubmit() {
          this.page = 1
          this.DataList()
      },

      handelDel(e) {
        this.$confirm('此操作将删除该过出列表, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          //console.log(param);
          this.$axios.delOverstep(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      // 点击弹出当前的图片
      handelDialog(index) {
        this.uploadDialog = true
        this.uploadImg = index.row.file_url.local_file_path
      }

    },
  };
</script>
<style>
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/car/leaveList.vue